
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class PsTaxInvoiceDtDialog extends Serenity.EntityDialog<PsTaxInvoiceDtRow, any> {
        protected getFormKey() { return PsTaxInvoiceDtForm.formKey; }
        // protected getIdProperty() { return PsTaxInvoiceDtRow.idProperty; }
        protected getLocalTextPrefix() { return PsTaxInvoiceDtRow.localTextPrefix; }
        protected getNameProperty() { return PsTaxInvoiceDtRow.nameProperty; }
        // protected getService() { return PsTaxInvoiceDtService.baseUrl; }
        // protected getDeletePermission() { return PsTaxInvoiceDtRow.deletePermission; }
        // protected getInsertPermission() { return PsTaxInvoiceDtRow.insertPermission; }
        // protected getUpdatePermission() { return PsTaxInvoiceDtRow.updatePermission; }

        protected form = new PsTaxInvoiceDtForm(this.idPrefix);
        protected getToolbarButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
           
            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();
                        // *** do something on click if you want **

                    },
                }
            );

            return buttons;
        }
    }
}